<template>
  <div>
    <head-nav-bar
      title="房务管理列表"
      :fixed="true"
      rightText="筛选"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <div class="search-area">
        <van-search
          class="search-date"
          v-model="accountDate"
          placeholder="账务日期"
          readonly
          clearable
          @click="showDate"
        >
          <template slot="right-icon">
            <van-icon
              name="clear"
              v-if="accountDate && tabName != 1"
              @click.stop="clearAccountDate"
            />
          </template>
        </van-search>
        <van-checkbox
          v-model="isOnlyMine"
          @change="onSearch"
          :disabled="!$auth('GuestRoomManage:AcceptCleaning')"
          >只查询自己</van-checkbox
        >
      </div>
      <van-tabs
        v-model="tabName"
        :swipe-threshold="swipeThreshold"
        title-active-color="#098ae8"
        @change="changeTab"
      >
        <van-tab
          v-for="(item, index) in roomLogStatus"
          :key="index"
          :name="item.Id"
        >
          <template slot="title">
            <strong style="position:relative">
              {{ item.Text }}
              <span class="badge-count" v-if="Number(otherInfo[item.Id]) > 0">{{
                otherInfo[item.Id]
              }}</span>
            </strong>
          </template>
        </van-tab>
      </van-tabs>
      <div class="room-service-list">
        <DataList
          ref="DataList"
          :api="getList"
          :params="params"
          :onLoadCallBack="onLoadCallBack"
        >
          <template v-slot:item="item">
            <van-collapse v-model="activeNames" class="clean-item">
              <van-collapse-item :name="item.Id">
                <template slot="title">
                  <div>
                    <van-tag color="#07c160" v-if="item.Status == 1"
                      >完
                    </van-tag>
                    <van-tag v-if="item.Status == 11" color="#199ed8"
                      >派
                    </van-tag>
                    <van-tag v-if="item.Status == 12" color="#faad14"
                      >清
                    </van-tag>
                    <van-tag v-if="item.Status == 13" color="#ec5b5b"
                      >验
                    </van-tag>
                    <van-tag v-if="item.Status == 14" color="#999">取 </van-tag>

                    <van-tag
                      :color="roomStatusType(item.CurrentRoomStatusName)"
                      round
                      style="margin-left:3px"
                    >
                      {{ item.CurrentRoomStatusName }}</van-tag
                    >
                    房号：{{ item.RoomNo }}
                  </div>
                  <div class="item-info">
                    清洁类型:
                    <span v-if="item.HandleRoomStatus == 2">离店房清洁 </span>
                    <span v-if="item.HandleRoomStatus == 1">续住房清洁 </span>
                    <small class="cleaner" v-if="item.HandlerName">
                      | 清洁员：{{ item.HandlerName }}
                    </small>
                  </div>
                  <div v-if="item.Reason" class="item-info">
                    信息: {{ item.Reason }}
                  </div>
                  <div v-if="item.Remark" class="item-info">
                    {{ item.Remark }}
                  </div>
                </template>
                <template slot="value">
                  <small>{{
                    moment(item.AccountDate).format("YYYY-MM-DD")
                  }}</small>
                </template>
                <ul>
                  <li
                    v-for="(el, elIndex) in item.CleanFlowQueryDetails"
                    :key="elIndex"
                  >
                    <div>{{ el.HandleTime }}</div>
                    <div>{{ el.StatusInfo }}</div>
                  </li>
                </ul>
              </van-collapse-item>
            </van-collapse>
            <div class="operate-section">
              <van-button
                size="mini"
                color="#f80"
                class="send-pass"
                @click="sendPass(item)"
                v-if="showSendPass"
                >补发密码</van-button
              >
              <van-button
                size="mini"
                type="info"
                @click="startClean(item)"
                v-if="item.Status == 11"
                >清洁</van-button
              >
              <van-button
                size="mini"
                type="primary"
                color="#199ed8"
                @click="endClean(item)"
                v-if="item.Status == 12"
                >完成</van-button
              >
              <van-button
                size="mini"
                type="primary"
                @click="acceptClean(item)"
                v-if="item.Status == 13"
                >验收</van-button
              >
              <!-- <van-button
                size="mini"
                type="danger"
                @click="cancelClean(item)"
                v-if="item.Status != 1 && item.Status != 14"
                >取消</van-button
              > -->
            </div>
          </template>
        </DataList>
      </div>
    </div>
    <van-dialog
      v-model="showReason"
      title="理由"
      show-cancel-button
      @confirm="confirmSubmit"
    >
      <van-field
        v-model="reason"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入理由"
      />
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchPopup from "@/components/searchPopup";
import DataList from "@/components/DataList";
import roomServiceApi from "@/api/roomService.js";
import { getSelectData, GetDefaultItem } from "@/api/common";
import DateTimePicker from "@/components/date-time-picker/function";
import moment from "moment";
import {
  tag,
  Search,
  Tab,
  Tabs,
  Row,
  Col,
  Icon,
  Dialog,
  Checkbox,
  Collapse,
  CollapseItem,
  Button,
  Notify,
  Field,
} from "vant";
export default {
  name: "OrderPage",
  components: {
    DataList,
    [Field.name]: Field,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Checkbox.name]: Checkbox,
    [Search.name]: Search,
    [tag.name]: tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {},
  data() {
    return {
      moment,
      getList: roomServiceApi.getCleanFlowPage,
      params: {},
      tabName: "11",
      swipeThreshold: 4,
      selectData: {},
      userId: "",
      accountDate: "",
      isOnlyMine: false,
      activeNames: [],
      roomLogStatus: [
        {
          Id: "11",
          Text: "指派中",
        },
        {
          Id: "12",
          Text: "清洁中",
        },
        {
          Id: "13",
          Text: "验收",
        },
        // {
        //   Id: "14",
        //   Text: "取消"
        // },
        {
          Id: "1",
          Text: "完成",
        },
      ],
      otherInfo: {},
      showSendPass: true,
      showReason: false,
      reason: "",
    };
  },
  model: {},
  created() {
    this.userId = this.user.OperaterId;
    this.isOnlyMine = !this.$auth("GuestRoomManage:AcceptCleaning");

    const active = this.$route.query.roomLogStatus;
    if (active) {
      this.tabName = String(active);
    }
    this.params = {
      ...this.params,
      IsOnlyMine: this.isOnlyMine,
      RoomLogStatus: this.tabName,
    };
    getSelectData({ types: "operater" }).then(res => {
      this.selectData = res.Data;
    });
    GetDefaultItem({}).then(res => {
      const json = {};
      res.Data.SystemConstList.forEach(item => {
        json[item.Code] = item.Value;
      });
      const lockConfig = JSON.parse(json.YunDingLock);
      if (!lockConfig.client_id && !lockConfig.client_secret) {
        this.showSendPass = false;
      } else {
        this.showSendPass = true;
      }
    });
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
    roomStatusType() {
      return function(val) {
        let color = "#333";
        if (val == "空房") {
          color = "#007bff";
        } else if (val == "占用") {
          color = "#f60";
        } else if (val == "维修") {
          color = "#f00";
        } else if (val == "封房") {
          color = "#f00";
        }
        return color;
      };
    },
  },
  watch: {},
  methods: {
    onLoadCallBack(res) {
      const other = res.Data.Other;
      if (other) {
        this.otherInfo = {
          "11": other.AppointCount,
          "12": other.CleaningCount,
          "13": other.AcceptanceCount,
        };
      }
    },
    showDate() {
      DateTimePicker({
        value: this.accountDate,
        format: "YYYY-MM-DD",
        change: val => {
          this.accountDate = val;
          this.params = {
            ...this.params,
            AccountDate: this.accountDate,
          };
        },
      });
    },
    clearAccountDate() {
      if (this.accountDate) {
        this.accountDate = "";
        this.params = {
          ...this.params,
          AccountDate: this.accountDate,
        };
      }
    },
    changeTab(key) {
      if (key == 1) {
        //查完成数据时必须选账务日期
        if (!this.accountDate) {
          this.accountDate = this.user.AccountDate;
          this.params.AccountDate = this.accountDate;
        }
      }
      this.params = {
        ...this.params,
        IsOnlyMine: this.isOnlyMine,
        RoomLogStatus: key,
      };
    },
    sendPass(item) {
      roomServiceApi.sendPasswordAgain({ Id: item.Id }).then(() => {
        Notify({ type: "success", message: "发送成功" });
        // this.$refs.DataList.reload();
      });
    },
    startClean(item) {
      roomServiceApi.startCleaning({ CleanRecordIds: [item.Id] }).then(() => {
        Notify({ type: "success", message: "操作成功" });
        this.$refs.DataList.reload();
      });
    },
    endClean(item) {
      roomServiceApi.endCleaning({ CleanRecordIds: [item.Id] }).then(() => {
        Notify({ type: "success", message: "操作成功" });
        this.$refs.DataList.reload();
      });
    },
    acceptClean(item) {
      const _this = this;
      Dialog.confirm({
        title: "是否通过验收？",
        cancelButtonText: "不通过",
        confirmButtonText: "通过",
        confirmButtonColor: "#009d3b",
        cancelButtonColor: "#f00",
      })
        .then(() => {
          _this.currentItem = item;
          _this.submitAcceptClean(item, false);
        })
        .catch(() => {
          _this.currentItem = item;
          // _this.submitAcceptClean(item, true);
          _this.reason = "";
          _this.showReason = true;
        });
    },
    confirmSubmit() {
      this.showReason = false;
      this.submitAcceptClean(this.currentItem, true);
    },
    submitAcceptClean(item, isAcceptFailed) {
      const reason = isAcceptFailed ? this.reason : "";
      roomServiceApi
        .acceptCleaning({
          CleanRecordIds: [item.Id],
          IsAcceptFailed: isAcceptFailed,
          Reason: reason,
        })
        .then(() => {
          Notify({ type: "success", message: "操作成功" });
          this.$refs.DataList.reload();
        });
    },
    cancelClean(item) {
      roomServiceApi.cancelCleaning({ CleanRecordIds: [item.Id] }).then(() => {
        Notify({ type: "success", message: "操作成功" });
        this.$refs.DataList.reload();
      });
    },
    onSearch() {
      this.params = {
        ...this.params,
        IsOnlyMine: this.isOnlyMine,
      };
    },

    onSearchClick() {
      searchPopup({
        title: "筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "操作员",
            name: "UserId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: this.userId,
            },
            data: this.selectData.operater,
          },
        ],
        submit: values => {
          const json = {
            ...values,
          };
          json.UserId = values.UserId ? values.UserId : null;
          this.userId = json.UserId;
          this.params = {
            ...this.params,
            ...json,
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.badge-count {
  position: absolute;
  top: 0;
  right: -5px;
  box-sizing: border-box;
  min-width: 0.42667rem;
  padding: 0 0.08rem;
  color: #fff;
  font-weight: 500;
  font-size: 0.32rem;
  font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
  line-height: 0.37333rem;
  text-align: center;
  background-color: #ee0a24;
  border: 0.02667rem solid #fff;
  border-radius: 0.42667rem;
  -webkit-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
}
.room-service-list {
  height: calc(100vh - 195px);
  overflow: auto;

  .data-list /deep/.list-item {
    padding: 5px;
    line-height: 20px;
    .clean-item {
      .van-collapse-item__content {
        background: #fffaf2;
        padding: 5px 10px;
        font-size: 12px;
        line-height: 20px;
        color: #ff8956;
        margin-top: 5px;
        li {
          border-bottom: 1px dashed #e8e8e8;
          padding-bottom: 5px;
          margin-bottom: 5px;
          &:last-child {
            border-bottom: 0;
            margin-bottom: 0;
            padding-bottom: 0;
          }
        }
      }
      .van-cell {
        padding: 5px;
        background: #edf8ff;
        .van-cell__title {
          flex: 3;
        }
        &.van-cell:not(:last-child)::after {
          border: 0;
        }
      }
      &.van-hairline--top-bottom::after,
      &.van-hairline-unset--top-bottom::after {
        border: 0;
      }
    }
    .operate-section {
      // display: flex;
      // justify-content: flex-end;
      padding-top: 5px;
      overflow: hidden;
      button {
        float: right;
        &.send-pass {
          padding: 0 6px;
          float: left;
        }
      }
    }
  }
}
.search-area {
  display: flex;
  font-size: 14px;
  padding-right: 10px;
  .search-date {
    flex: 4;

    &:not(:last-child)::after {
      border-bottom: 0;
    }
    /deep/.van-checkbox__label {
      color: #999;
    }
  }
}
.cleaner {
  color: #999;
}
.item-info {
  width: calc(100% + 100px);
}
</style>
